// extracted by mini-css-extract-plugin
export default {"tooltip":"ConfiguredTooltip_tooltip__9TcEZ","tooltipBold":"ConfiguredTooltip_tooltipBold__LluoC","label":"ConfiguredTooltip_label__62Um1"};